import { useEffect, useState } from "react";

import ExpandOrShrinkIcon from "../../../../../../../Components/UI/DropDown/ExpandOrShrinkIcon";

import "./styles.scss";

const TypeCard = ({
  className = "",
  selectedFile,
  setSelectedFile,
  title,
  active,
  itemArray,
  itemTitleKeyword,
  onClick,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (selectedFile && typeof selectedFile === "object" && itemTitleKeyword in selectedFile) {
      setIsOpen(true);
    }
  }, [selectedFile, itemTitleKeyword]);

  const clickHandler = () => {
    setIsOpen((prevValue) => !prevValue);
    onClick(title);
  };

  return (
    <>
      <div
        className={`thunter-additional-data__sidebar__type-card ${className}`}
        onClick={clickHandler}>
        {title}({itemArray.length}) <ExpandOrShrinkIcon expanded={isOpen} collapsed={false} />
      </div>
      {isOpen && itemArray.length ? (
        <div className="thunter-additional-data__sidebar__type-card__files">
          {itemArray.map((item, i) => (
            <div
              className={`thunter-additional-data__sidebar__type-card__file ${
                item.threats &&
                item.threats.some((threat) => threat.severity && threat.severity === "high")
                  ? "thunter-additional-data__sidebar__type-card__file--matched"
                  : "thunter-additional-data__sidebar__type-card__file--unmatched"
              }`}
              // ${
              //   selectedFile?.id === file.id
              //     ? "thunter-additional-data__sidebar__type-card__file--active"
              //     : ""
              // }`
              // }
              key={i}
              onClick={() => setSelectedFile(item)}>
              <p className="thunter-additional-data__sidebar__type-card__file__name">
                {item[itemTitleKeyword]}
              </p>
              {selectedFile?.[itemTitleKeyword] === item[itemTitleKeyword] ? (
                <div className="thunter-additional-data__sidebar__type-card__file__active-circle"></div>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default TypeCard;
